export default __webpack_public_path__ + "static/media/FinalLogo.e4678c44.png";